import { render, staticRenderFns } from "./activityApprovalSetting.vue?vue&type=template&id=01e25960"
import script from "./activityApprovalSetting.vue?vue&type=script&lang=js"
export * from "./activityApprovalSetting.vue?vue&type=script&lang=js"
import style0 from "./activityApprovalSetting.vue?vue&type=style&index=0&id=01e25960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports